/*
 * @Description: 无
 * @Date: 1621-01-11 10:30:17
 * @LastEditTime: 1624-01-08 16:40:48
 */
import { ImagePreview } from 'vant'

export default {
  methods: {
    devPR () {
      const fontSize = window.document.documentElement.style.fontSize
      if (fontSize) {
        return Math.ceil(parseInt(fontSize) || 16) / 16
      }
      return 16
    },
    /**
     * @method
     * @name: _pxToRem
     * @description: 将富文本中的px转成rem
     * @param: {String} [content] 富文本内容
     * @return: {String} [str]
     */
    addStylesToPreventOverflow (doc) {
      // Select all block-level elements that might cause overflow
      const blockElements = doc.querySelectorAll('div, p, h1, h2, h3, h4, h5, h6, section, article, aside, footer, header, nav, main')
      blockElements.forEach(el => {
        // el.style.width = '100%'
        el.style.boxSizing = 'border-box'
        el.style.maxWidth = '100%'
        el.style.marginLeft = '0'
        el.style.marginRight = '0'
      })

      // Select all elements to ensure text doesn't overflow
      const allElements = doc.querySelectorAll('*')
      allElements.forEach(el => {
        if (!el.style.wordBreak) {
          el.style.wordBreak = 'break-all'
        }
        if (!el.style.overflowWrap) {
          el.style.overflowWrap = 'break-word'
        }
      })
    },
    _pxToRem (cssString) {
      if (!this.devPR()) {
        return cssString
      }

      if (cssString) {
        // Helper function to convert units and clean up spaces
        const convertUnits = (unit, factor) => cssString.replace(
          new RegExp(`([:|(]*)(\\s*)([-+]?[0-9]*\\.?[0-9]+)(${unit})`, 'g'),
          (match, prefix, space, value) => `${prefix}${space}${parseFloat(value) * factor}rem`
        )

        // Convert px and pt units to rem
        cssString = convertUnits('px', 1 / 16)
          .replace(/([:|(]*)(\s*)([-+]?[0-9]*\.?[0-9]+)(pt)/g, (match, prefix, space, value) =>
            `${prefix}${space}${parseFloat(value) / 16 * 130 / 100}rem`)

        // Clean up extra spaces between tags
        cssString = cssString.replace(/>\s+</g, '><')

        // Ensure images have a width of 100%
        cssString = this.addWidthToImages(cssString)

        // Parse the CSS string into a document fragment
        const parser = new DOMParser()
        const doc = parser.parseFromString(`<div>${cssString}</div>`, 'text/html')

        // Add styles to prevent content from overflowing
        this.addStylesToPreventOverflow(doc.body)

        // Serialize the modified document back to a string
        const serializer = new XMLSerializer()
        const serializedDoc = serializer.serializeToString(doc.body).replace(/^<body>|<\/body}$/g, '')

        return serializedDoc
      }

      return cssString
    },
    addWidthToImages (richText) {
      // 定义一个正则表达式来匹配 <img> 标签
      const imgRegex = /<img[^>]+>/gi

      // 定义一个函数用于替换每个找到的 <img> 标签
      function replaceImgTag (imgTag) {
        // 使用正则表达式检查是否已经有 width: 100%
        const hasWidthStyle = /style=["'](.*?width:\s*100% !important;.*?)["']/i.test(imgTag)
        if (hasWidthStyle) {
          return imgTag // 如果已经存在宽度为100%，直接返回原始标签
        }

        // 检查 <img> 标签是否有 style 属性
        const hasStyleAttr = /style=["'][^"']*["']/i.test(imgTag)

        if (hasStyleAttr) {
          // 如果有 style 属性，则在其内部添加 width: 100% !important;
          return imgTag.replace(/(style=["'])([^"']*?)["']/i, `$1 width: 100% !important;$2"`)
        } else {
          // 如果没有 style 属性，则创建一个新的 style 属性
          return imgTag.replace(/(<img[^>]*?)\/?>/i, `$1 style="width: 100% !important;" />`)
        }
      }
      // 使用正则表达式的 replace 方法和自定义的替换函数处理富文本
      return richText.replace(imgRegex, replaceImgTag)
    },
    /**
     * @method
     * @name: _getUnit
     * @description: 将富文本中的px转成rem
     * @param: {String} [content] 富文本内容
     * @return: {String} [str]
     */
    _getUnit (num) {
      return num / 16 + 'rem'
    },
    /**
     * @method
     * @name: _getEm
     * @description: 获取指定行数的高度
     * @param: {Number}} [line] 行数
     * @param: {Number}} [lh] 行高
     * @return: {String}} em单位的高度
     */
    _getEm (line, lh = 1.4) {
      return `${line * lh}em`
    },
    /**
     * @method
     * @name: _handleRichImg
     * @description: 处理富文本图片，加载完成事件，点击事件等
     * @param: {Function} [loadFn] 图片加载完成回调
     * {Function} [clickFn] 图片点击回调
     * {String} [content] parent
     */
    _handleRichImg ({ loadFn, clickFn, parent = '.article-main' } = {}) {
      let list = []
      this.$nextTick(() => {
        let imgs = document.querySelectorAll(`${parent} img`)
        imgs.forEach((img, index) => {
          list.push(img.src)
          if (loadFn && typeof loadFn === 'function') {
            img.addEventListener('load', loadFn)
          }
          if (clickFn && typeof clickFn === 'function') {
            img.addEventListener('click', () => {
              clickFn(index, img.src)
            })
          }
        })
      })
      return list
    },
    /**
     * @method
     * @name: _handleRichVideo
     * @description: 处理富文本视频
     * @param: {Function} [playFn] 视频播放
     * {String} [content] parent
     */
    _handleRichVideo ({
      onGetedAllFn,
      eachFn,
      playFn,
      parent = '.article-main'
    } = {}) {
      let videos = []
      this.$nextTick(() => {
        videos = document.querySelectorAll(`${parent} video`)
        if (onGetedAllFn && typeof onGetedAllFn === 'function') {
          onGetedAllFn(videos)
        }
        videos.forEach((video, index) => {
          if (playFn && typeof playFn === 'function') {
            video.addEventListener('play', playFn)
          }
          if (eachFn && typeof eachFn === 'function') {
            eachFn(video, index, index === videos.length - 1)
          }
        })
      })
      return videos
    },
    /**
     * @method
     * @name: _onPreview
     * @description: 富文本图片预览
     * @param: {String} [content] 富文本内容
     */
    _onPreview (index, imgs = []) {
      // 预览图片
      ImagePreview({
        images: imgs,
        startPosition: index || 0,
        closeable: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/Style.js